import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const ROOT_ROUTE_REF = createRouteRef({
  id: 'deploy-next-app',
});

export const DEPLOYMENT_DETAILS_SUBROUTE_REF = createSubRouteRef({
  parent: ROOT_ROUTE_REF,
  path: '/deployment/:vcs/:project/:repo/:gitRef',
  id: 'deployment-configuration',
});

export const REPOSITORY_SUBROUTE_REF = createSubRouteRef({
  parent: ROOT_ROUTE_REF,
  path: '/repository/:vcs/:project/:repo',
  id: 'repository-details',
});

export const DEFAULT_CONFIG_SUBROUTE_REF = createSubRouteRef({
  parent: ROOT_ROUTE_REF,
  path: '/default-config/:vcs/:project/:repo/:configDir',
  id: 'default-config-details',
});
